import React from "react";

const UserIcon: React.FC = () => {
  return (
    <svg
      width="800px"
      height="800px"
      viewBox="0 -2 16 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 7C9.65685 7 11 5.65685 11 4C11 2.34315 9.65685 1 8 1C6.34315 1 5 2.34315 5 4C5 5.65685 6.34315 7 8 7Z"
        fill="#FFFFFF"
      />
      <path
        d="M14 12C14 10.3431 12.6569 9 11 9H5C3.34315 9 2 10.3431 2 12V15H14V12Z"
        fill="#FFFFFF"
      />
    </svg>
  );
};

export default UserIcon;
